import scrollToTop from './util/scrollToTop'
import ellipsis from './util/ellipsis'
import nav from './partial/nav'
import animation from './partial/animate'

/*
 * on domContentLoaded
 */
$(function () {
  FastClick.attach(document.body)

  scrollToTop()
  ellipsis()
  nav()
  animation() 
})